import type { PropsWithChildren } from 'react';

import { styled } from '/imports/ui/foundation/Theme';

type SealProps = PropsWithChildren<{
  patchy?: boolean;
  tilted?: boolean;
}>;

export const Seal = ({ children, patchy, tilted }: SealProps) => (
  <>
    {patchy && <PatchesSvgFilter />}
    <StyledSeal patchy={patchy} tilted={tilted}>
      {children}
    </StyledSeal>
  </>
);

const StyledSeal = styled('div', ({ tokens }) => ({
  display: 'inline-block',
  border: `3px solid ${tokens.colorSuccess}`,
  borderRadius: tokens.borderRadius,
  color: tokens.colorSuccess,
  fontWeight: tokens.fontWeightStrong,
  paddingBlock: tokens.paddingXXS,
  paddingInline: tokens.paddingXS,
  userSelect: 'none',

  variants: {
    patchy: {
      true: {
        filter: 'url(#patchy)',
      },
    },
    tilted: {
      true: {
        transform: 'rotate(-3deg)',
      },
    },
  },
}));

const PatchesSvgFilter = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }}>
    <defs>
      <filter id="patchy" x="0" y="0" width="100%" height="100%">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.25" // size of patches
          numOctaves="3"
          seed="8"
          result="grain"
        />
        <feColorMatrix
          in="grain"
          type="matrix"
          // Last number defines the "patchiness", ranges from ca. 0 (no patches) to -12 (all gone)
          values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  14 0 0 0 -3.2"
          result="mask"
        />
        <feComposite in="SourceGraphic" in2="mask" operator="in" />
      </filter>
    </defs>
  </svg>
);
